import { createAction, handleActions } from 'redux-actions';
import { _getScheduleList,_getScheduleListofWeek,_getSlotesList,_getSlotesListofWeek,_approveAppointment,_rejectAppointment,_createSlot,_getBlockScheduleList, _getBlockScheduleListforDay,_getSchedulesOnDateList,_getSlotesOnDateList, _getBlockSchedulesOnDateList, _getBlockSchedulesOnDateListRecurring, _getUnBlockSchedulesOnDateList, _startService,_sendEmail, _getAppointmentDetailsById,_getSlotsDetailsById, _stopService, _getSchedulesOnDateByPagination, _editAppointmentDetails,_editSlotDetails,_paymentDetails, _cancelAppointment , _cancelSlot } from '~shared/httpService/apis';
import ActionTypes from '~shared/constants/actionTypes';
import { _waiveService } from '../../../shared/httpService/apis';

const initialState = {
  schedule_list: { loading: false, response: [], hasError: false, error: {} },
  schedule_list_for_day: { loading: false, response: [], hasError: false, error: {} },
  schedule_list_week: { loading: false, response: [], hasError: false, error: {} },
  slotes_list: { loading: false, response: [], hasError: false, error: {} },
  slotes_list_week: { loading: false, response: [], hasError: false, error: {} },
  schedules_on_date: { loading: false, response: [], hasError: false, error: {} },
  slotes_on_date:{ loading: false, response: [], hasError: false, error: {} },
  send_email: { loading: false, response: [], hasError: false, error: {} },
  start_service: { loading: false, response: [], hasError: false, error: {} },
  stop_service: { loading: false, response: [], hasError: false, error: {} },
  details_by_id: { loading: false, response: [], hasError: false, error: {} },
  slots_details_by_id: { loading: false, response: [], hasError: false, error: {} },
  schedules_by_pagination: { loading: false, response: [], hasError: false, error: {} },
  edit_appointment: { loading: false, response: [], hasError: false, error: {} },
  edit_slot: { loading: false, response: [], hasError: false, error: {} },
  cancel_appointment: { loading: false, response: [], hasError: false, error: {} },
  approve_appointment: { loading: false, response: [], hasError: false, error: {} },
  reject_appointment: { loading: false, response: [], hasError: false, error: {} },
  cancel_slot: { loading: false, response: [], hasError: false, error: {} },
  waive_Service:{loading: false, response:[], hasError: false, error:{}},
  create_slot: {loading: false, response:[], hasError: false, error:{}},
};

export const getScheduleListStart = createAction(ActionTypes.GET_SCHEDULE_LIST);
export const getScheduleListSuccess = createAction(ActionTypes.GET_SCHEDULE_LIST_SUCCESS, response => response);
export const getScheduleListError = createAction(ActionTypes.GET_SCHEDULE_LIST_ERROR, error => error);

export const getScheduleList = (date) => (dispatch) => {
  dispatch(getScheduleListStart());
  return _getScheduleList(date).then((response) => {
    dispatch(getScheduleListSuccess(response));
  }).catch((error) => {
    dispatch(getScheduleListError(error));
  });
};


export const getScheduleListofWeekStart = createAction(ActionTypes.GET_SCHEDULE_LIST_WEEK);
export const getScheduleListofWeekSuccess = createAction(ActionTypes.GET_SCHEDULE_LIST_WEEK_SUCCESS, response => response);
export const getScheduleListofWeekError = createAction(ActionTypes.GET_SCHEDULE_LIST_WEEK_ERROR, error => error);

export const getScheduleListofWeek = (date) => (dispatch) => {
  dispatch(getScheduleListStart());
  return _getScheduleListofWeek(date).then((response) => {
    dispatch(getScheduleListofWeekSuccess(response));
  }).catch((error) => {
    dispatch(getScheduleListofWeekError(error));
  });
};

export const getSlotesListStart = createAction(ActionTypes.GET_SLOTES_LIST);
export const getSlotesListSuccess = createAction(ActionTypes.GET_SLOTES_LIST_SUCCESS, response => response);
export const getSlotesListError = createAction(ActionTypes.GET_SLOTES_LIST_ERROR, error => error);

export const getSlotesList = (date) => (dispatch) => {
  dispatch(getSlotesListStart());
  return _getSlotesList(date).then((response) => {
    dispatch(getSlotesListSuccess(response));
  }).catch((error) => {
    dispatch(getSlotesListError(error));
  });
};


export const getSlotesListofWeekStart = createAction(ActionTypes.GET_SLOTES_LIST_WEEK);
export const getSlotesListofWeekSuccess = createAction(ActionTypes.GET_SLOTES_LIST_WEEK_SUCCESS, response => response);
export const getSlotesListofWeekError = createAction(ActionTypes.GET_SLOTES_LIST_WEEK_ERROR, error => error);

export const getSlotesListofWeek = (date) => (dispatch) => {
  dispatch(getSlotesListofWeekStart());
  return _getSlotesListofWeek(date).then((response) => {
    dispatch(getSlotesListofWeekSuccess(response));
  }).catch((error) => {
    dispatch(getSlotesListofWeekError(error));
  });
};

//createslotfunction

export const createSlotStart = createAction(ActionTypes.CREATE_SLOT);
export const createSlotSuccess = createAction(ActionTypes.CREATE_SLOT_SUCCESS, response => response);
export const createSlotError = createAction(ActionTypes.CREATE_SLOT_ERROR, error => error);

export const createSlot = (data) => (dispatch) => {
  dispatch(createSlotStart());
  return _createSlot(data).then((response) => {
    console.log(response,"resss")
    dispatch(createSlotSuccess(response));
  }).catch((error) => {
     dispatch(createSlotError(error));
  });
};










export const getBlockScheduleListStart = createAction(ActionTypes.GET_SCHEDULE_LIST);
export const getBlockScheduleListSuccess = createAction(ActionTypes.GET_SCHEDULE_LIST_SUCCESS, response => response);
export const getBlockScheduleListError = createAction(ActionTypes.GET_SCHEDULE_LIST_ERROR, error => error);

export const getBlockScheduleList = (date) => (dispatch) => {
  dispatch(getBlockScheduleListStart());
  return _getBlockScheduleList(date).then((response) => {
    dispatch(getBlockScheduleListSuccess(response));
  }).catch((error) => {
    dispatch(getBlockScheduleListError(error));
  });
};


export const getBlockScheduleListforDayStart = createAction(ActionTypes.GET_SCHEDULE_LIST_FOR_DAY);
export const getBlockScheduleListforDaySuccess = createAction(ActionTypes.GET_SCHEDULE_LIST_FOR_DAY_SUCCESS, response => response);
export const getBlockScheduleListforDayError = createAction(ActionTypes.GET_SCHEDULE_LIST_FOR_DAY_ERROR, error => error);

export const getBlockScheduleListforDay = ({formatedDate,tz,type}) => (dispatch) => {
  console.log(formatedDate,"formateddate")
  dispatch(getBlockScheduleListforDayStart());
  return _getBlockScheduleListforDay({formatedDate,tz,type}).then((response) => {
    dispatch(getBlockScheduleListforDaySuccess(response));
  }).catch((error) => {
    dispatch(getBlockScheduleListforDayError(error));
  });
};

export const getSchedulesOnDateListStart = createAction(ActionTypes.GET_SCHEDULES_ON_DATE_LIST);
export const getSchedulesOnDateListSuccess = createAction(ActionTypes.GET_SCHEDULES_ON_DATE_LIST_SUCCESS, response => response);
export const getSchedulesOnDateListError = createAction(ActionTypes.GET_SCHEDULES_ON_DATE_LIST_ERROR, error => error);

export const getSchedulesOnDateList = (date = '', page = '') => (dispatch) => {
  dispatch(getSchedulesOnDateListStart());
  return _getSchedulesOnDateList(date, page).then((response) => {
    dispatch(getSchedulesOnDateListSuccess(response));
  }).catch((error) => {
    dispatch(getSchedulesOnDateListError(error));
  });
};






// BKI-1232

export const getSlotesOnDateListStart = createAction(ActionTypes.GET_SLOTES_ON_DATE_LIST);
export const getSlotesOnDateListSuccess = createAction(ActionTypes.GET_SLOTES_ON_DATE_LIST_SUCCESS, response => response);
export const getSlotesOnDateListError = createAction(ActionTypes.GET_SLOTES_ON_DATE_LIST_ERROR, error => error);

export const getSlotesOnDateList = (slotDateTime= '', page = '') => (dispatch) => {
  dispatch(getSlotesOnDateListStart());
  return _getSlotesOnDateList(slotDateTime, page).then((response) => {
    dispatch(getSlotesOnDateListSuccess(response));
  }).catch((error) => {
    dispatch(getSlotesOnDateListError(error));
  });
};



export const getBlockSchedulesOnDateListStart = createAction(ActionTypes.GET_SCHEDULES_ON_DATE_LIST);
export const getBlockSchedulesOnDateListSuccess = createAction(ActionTypes.GET_SCHEDULES_ON_DATE_LIST_SUCCESS, response => response);
export const getBlockSchedulesOnDateListError = createAction(ActionTypes.GET_SCHEDULES_ON_DATE_LIST_ERROR, error => error);

export const getBlockSchedulesOnDateList = (data) => (dispatch) => {
   dispatch(getBlockSchedulesOnDateListStart());
  return _getBlockSchedulesOnDateList(data).then((response) => {
    dispatch(getBlockSchedulesOnDateListSuccess(response));
  }).catch((error) => {
    dispatch(getBlockSchedulesOnDateListError(error));
  });
};

export const getBlockSchedulesOnDateListRecurring = (data) => (dispatch) => {
   dispatch(getBlockSchedulesOnDateListStart());
  return _getBlockSchedulesOnDateListRecurring(data).then((response) => {
    dispatch(getBlockSchedulesOnDateListSuccess(response));
  }).catch((error) => {
    dispatch(getBlockSchedulesOnDateListError(error));
  });
};

export const getUnBlockSchedulesOnDateListStart = createAction(ActionTypes.GET_SCHEDULES_ON_DATE_LIST);
export const getUnBlockSchedulesOnDateListSuccess = createAction(ActionTypes.GET_SCHEDULES_ON_DATE_LIST_SUCCESS, response => response);
export const getUnBlockSchedulesOnDateListError = createAction(ActionTypes.GET_SCHEDULES_ON_DATE_LIST_ERROR, error => error);

export const getUnBlockSchedulesOnDateList = (date = '') => (dispatch) => {
  dispatch(getUnBlockSchedulesOnDateListStart());
  return _getUnBlockSchedulesOnDateList(date).then((response) => {
    dispatch(getUnBlockSchedulesOnDateListSuccess(response));
  }).catch((error) => {
    dispatch(getUnBlockSchedulesOnDateListError(error));
  });
};

export const startServiceStart = createAction(ActionTypes.START_SERVICE);
export const startServiceSuccess = createAction(ActionTypes.START_SERVICE_SUCCESS, response => response);
export const startServiceError = createAction(ActionTypes.START_SERVICE_ERROR, error => error);

export const startService = (id, startServiceAt,createdCustomerId,createdCustomerName) => (dispatch) => {
  dispatch(startServiceStart());
  return _startService(id, startServiceAt,createdCustomerId,createdCustomerName).then((response) => {
    dispatch(startServiceSuccess(response));
  }).catch((error) => {
    dispatch(startServiceError(error));
  });
};

export const startEmailStart = createAction(ActionTypes.SEND_EMAIL);
export const startEmailSuccess = createAction(ActionTypes.SEND_EMAIL_SUCCESS, response => response);
export const startEmailError = createAction(ActionTypes.SEND_EMAIL_ERROR, error => error);

export const sendEmail = (date) => (dispatch) => {
  dispatch(startEmailStart());
  return _sendEmail(date).then((response) => {
    dispatch(startEmailSuccess(response));
  }).catch((error) => {
    dispatch(startEmailError(error));
  });
};


export const stopServiceStart = createAction(ActionTypes.STOP_SERVICE);
export const stopServiceSuccess = createAction(ActionTypes.STOP_SERVICE_SUCCESS, response => response);
export const stopServiceError = createAction(ActionTypes.STOP_SERVICE_ERROR, error => error);

export const stopService = (id, data, createdCustomerId, createdCustomerName) => (dispatch) => {
  const adjustment = data?.adjustmentQuotes
  let formdata = new FormData();
  formdata.append('quoteAdjustmentRemoveIds',data?.quoteAdjustmentRemoveIds)
  adjustment.map((item,index)=>{
    formdata.append(`adjustmentQuotes[${index}].quotename`,item.quoteName)
    formdata.append(`adjustmentQuotes[${index}].quoteprice`,item.quotePrice)
    formdata.append(`adjustmentQuotes[${index}].quoteAdjustmentId`,item.quoteAdjustmentId)
  })
  formdata.append('totalCost', data?.totalCost);
  formdata.append('combId', data?.combId);
  formdata.append('bladeId', data?.bladeId);
  formdata.append('petShampooId', data?.petShampooId);
  formdata.append('petCologneId', data?.petCologneId);
  formdata.append('foodFed', data?.foodFed);
  formdata.append('poopDescription', data?.poopDescription);
  formdata.append('timesFed', data?.timesFed);
  formdata.append('timesPeed', data?.timesPeed);
  formdata.append('timesPooped', data?.timesPooped);
  formdata.append('notes', data?.notes);
  formdata.append('isFilledWaterBowl', data?.isFilledWaterBowl);
  formdata.append('serviceEndAt', data?.serviceEndAt);
  // formdata.append('actualOvernights', data?.actualOvernights);
  formdata.append('cupFedPerTime', data?.cupFedPerTime);
  data?.photos?.map((item, index) => {
    formdata.append(`photos[${index}]`, item);
  });
  
  dispatch(stopServiceStart());
  return _stopService(id, formdata, createdCustomerId, createdCustomerName).then((response) => {
    dispatch(stopServiceSuccess(response));
  }).catch((error) => {
    dispatch(stopServiceError(error));
  });
};

export const getAppointmentDetailsByIdStart = createAction(ActionTypes.GET_APPOINTMENT_DETAILS_BY_ID);
export const getAppointmentDetailsByIdSuccess = createAction(ActionTypes.GET_APPOINTMENT_DETAILS_BY_ID_SUCCESS, response => response);
export const getAppointmentDetailsByIdError = createAction(ActionTypes.GET_APPOINTMENT_DETAILS_BY_ID_ERROR, error => error);

export const getAppointmentDetailsById = (id) => (dispatch) => {
  dispatch(getAppointmentDetailsByIdStart());
  return _getAppointmentDetailsById(id).then((response) => {
    dispatch(getAppointmentDetailsByIdSuccess(response));
  }).catch((error) => {
    dispatch(getAppointmentDetailsByIdError(error));
  });
};

// BKI-1232
export const getSlotDetailsByIdStart = createAction(ActionTypes.GET_SLOT_DETAILS_BY_ID);
export const getSlotDetailsByIdSuccess = createAction(ActionTypes.GET_SLOT_DETAILS_BY_ID_SUCCESS, response => response);
export const getSlotDetailsByIdError = createAction(ActionTypes.GET_SLOT_DETAILS_BY_ID_ERROR, error => error);

export const getSlotDetailsById = (id) => (dispatch) => {
  dispatch(getSlotDetailsByIdStart());
  return _getSlotsDetailsById(id).then((response) => {
    dispatch(getSlotDetailsByIdSuccess(response));
  }).catch((error) => {
    dispatch(getSlotDetailsByIdError(error));
  });
};

export const paymentDetailsStart = createAction(ActionTypes.GET_APPOINTMENT_DETAILS_BY_ID);
export const paymentDetailsIdSuccess = createAction(ActionTypes.GET_APPOINTMENT_DETAILS_BY_ID_SUCCESS, response => response);
export const paymentDetailsError = createAction(ActionTypes.GET_APPOINTMENT_DETAILS_BY_ID_ERROR, error => error);

export const paymentDetails = (id) => (dispatch) => {
  dispatch(paymentDetailsStart());
  return _paymentDetails(id).then((response) => {
     dispatch(paymentDetailsIdSuccess(response))
  }).catch((error) => {
    dispatch(paymentDetailsError(error))
  })
}

// paymentDetails

export const editAppointmentDetailsStart = createAction(ActionTypes.EDIT_APPOINTMENT_DETAILS);
export const editAppointmentDetailsSuccess = createAction(ActionTypes.EDIT_APPOINTMENT_DETAILS_SUCCESS, response => response);
export const editAppointmentDetailsError = createAction(ActionTypes.EDIT_APPOINTMENT_DETAILS_ERROR, error => error);

export const editAppointmentDetails = (id, date, time, endtime, tz, createdCustomerId, createdCustomerName) => (dispatch) => {
  dispatch(editAppointmentDetailsStart());
  return _editAppointmentDetails(id, date, time, endtime, tz, createdCustomerId, createdCustomerName).then((response) => {
    dispatch(editAppointmentDetailsSuccess(response));
  }).catch((error) => {
    dispatch(editAppointmentDetailsError(error));
  });
};


export const editSlotDetailsStart = createAction(ActionTypes.EDIT_SLOT_DETAILS);
export const editSlotDetailsSuccess = createAction(ActionTypes.EDIT_SLOT_DETAILS_SUCCESS, response => response);
export const editSlotDetailsError = createAction(ActionTypes.EDIT_SLOT_DETAILS_ERROR, error => error);

export const editSlotDetails = (data,id,enable) => (dispatch) => {
  dispatch(editSlotDetailsStart());
  return _editSlotDetails(data,id,enable).then((response) => {
    dispatch(editSlotDetailsSuccess(response));
  }).catch((error) => {
    dispatch(editSlotDetailsError(error));
  });
};

export const getSchedulesOnDateByPaginationStart = createAction(ActionTypes.GET_SCHEDULES_ON_DATE_BY_PAGINATION_LIST);
export const getSchedulesOnDateByPaginationSuccess = createAction(ActionTypes.GET_SCHEDULES_ON_DATE_BY_PAGINATION_LIST_SUCCESS, response => response);
export const getSchedulesOnDateByPaginationError = createAction(ActionTypes.GET_SCHEDULES_ON_DATE_BY_PAGINATION_LIST_ERROR, error => error);

export const getSchedulesOnDateByPagination = (date = '', page = '', pageSize, query = '') => (dispatch) => {
  dispatch(getSchedulesOnDateByPaginationStart());
  return _getSchedulesOnDateByPagination(date, page, pageSize, query).then((response) => {
    dispatch(getSchedulesOnDateByPaginationSuccess(response));
  }).catch((error) => {
    dispatch(getSchedulesOnDateByPaginationError(error));
  });
};

export const cancelAppointmentStart = createAction(ActionTypes.CANCEL_APPOINTMENT);
export const cancelAppointmentSuccess = createAction(ActionTypes.CANCEL_APPOINTMENT_SUCCESS, response => response);
export const cancelAppointmentError = createAction(ActionTypes.CANCEL_APPOINTMENT_ERROR, error => error);

export const cancelAppointment = (id, tz , cancellationReason, createdCustomerId,createdCustomerName) => (dispatch) => {
  dispatch(cancelAppointmentStart());
  return _cancelAppointment(id, tz , cancellationReason,createdCustomerId,createdCustomerName).then((response) => {
    dispatch(cancelAppointmentSuccess(response));
  }).catch((error) => {
    dispatch(cancelAppointmentError(error));
  });
};


export const approveAppointmentStart = createAction(ActionTypes.APPROVE_APPOINTMENT);
export const approveAppointmentSuccess = createAction(ActionTypes.APPROVE_APPOINTMENT_SUCCESS, response => response);
export const approveAppointmentError = createAction(ActionTypes.APPROVE_APPOINTMENT_ERROR, error => error);

export const approveAppointment = (id, tz, createdCustomerId, createdCustomerName) => (dispatch) => {
  dispatch(approveAppointmentStart());
  return _approveAppointment(id, tz, createdCustomerId, createdCustomerName).then((response) => {
    dispatch(approveAppointmentSuccess(response));
  }).catch((error) => {
    dispatch(approveAppointmentError(error));
  });
};


export const rejectAppointmentStart = createAction(ActionTypes.REJECT_APPOINTMENT);
export const rejectAppointmentSuccess = createAction(ActionTypes.REJECT_APPOINTMENT_SUCCESS, response => response);
export const rejectAppointmentError = createAction(ActionTypes.REJECT_APPOINTMENT_ERROR, error => error);

export const rejectAppointment = (id, tz, rejectionReason, createdCustomerId, createdCustomerName) => (dispatch) => {
  dispatch(rejectAppointmentStart());
  return _rejectAppointment(id, tz, rejectionReason, createdCustomerId, createdCustomerName).then((response) => {
    dispatch(rejectAppointmentSuccess(response));
  }).catch((error) => {
    dispatch(rejectAppointmentError(error));
  });
};

// cancel slot function


export const cancelSlotStart = createAction(ActionTypes.CANCEL_SLOT);
export const cancelSlotSuccess = createAction(ActionTypes.CANCEL_SLOT_SUCCESS, response => response);
export const cancelSlotError = createAction(ActionTypes.CANCEL_SLOT_ERROR, error => error);

export const cancelSlot = (id, deleteall,tz) => (dispatch) => {
  dispatch(cancelSlotStart());
  return _cancelSlot(id, deleteall,tz).then((response) => {
    dispatch(cancelSlotSuccess(response));
  }).catch((error) => {
    dispatch(cancelSlotError(error));
  });
};

export const waiveServiceStart = createAction(ActionTypes.WAIVE);
export const waiveServiceSuccess = createAction(ActionTypes.WAIVE_SUCCESS, response => response);
export const waiveServiceError= createAction(ActionTypes.WAIVE_ERROR, error => error);

export const waiveServices = (id, createdCustomerId, createdCustomerName) => (dispatch)=>{
  dispatch(waiveServiceStart());
  return _waiveService(id, createdCustomerId, createdCustomerName).then((response)=>{
    dispatch(waiveServiceSuccess(response));

  }).catch((error)=>{
    dispatch(waiveServiceError(error));
  })
}

const reducer = handleActions({

  //WAIVE
  [ActionTypes.WAIVE]: (state) => ({
    ...state, 
    waive_Service: {
      ...state.waive_Service,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.WAIVE_SUCCESS]: (state, action) => ({
    ...state,
    waive_Service: {
      ...state.waive_Service,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.WAIVE_ERROR]: (state, action) => ({
    ...state,
    waive_Service: {
      ...state.waive_Service,
      error: action.payload, loading: false, hasError: true
    }
  }),

  //SCHEDULE_LIST
  [ActionTypes.GET_SCHEDULE_LIST]: (state) => ({
    ...state, schedule_list: {
      ...state.schedule_list,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SCHEDULE_LIST_SUCCESS]: (state, action) => ({
    ...state,
    schedule_list: {
      ...state.schedule_list,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SCHEDULE_LIST_ERROR]: (state, action) => ({
    ...state,
    schedule_list: {
      ...state.schedule_list,
      error: action.payload, loading: false, hasError: true
    }
  }),


   //SCHEDULE_LIST
   [ActionTypes.GET_SCHEDULE_LIST_FOR_DAY]: (state) => ({
    ...state, schedule_list_for_day: {
      ...state.schedule_list_for_day,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SCHEDULE_LIST_FOR_DAY_SUCCESS]: (state, action) => ({
    ...state,
    schedule_list_for_day: {
      ...state.schedule_list_for_day,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SCHEDULE_LIST_FOR_DAY_ERROR]: (state, action) => ({
    ...state,
    schedule_list_for_day: {
      ...state.schedule_list_for_day,
      error: action.payload, loading: false, hasError: true
    }
  }),



  //WEEKVIEW

  [ActionTypes.GET_SCHEDULE_LIST_WEEK]: (state) => ({
    ...state, schedule_list_week: {
      ...state.schedule_list_week,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SCHEDULE_LIST_WEEK_SUCCESS]: (state, action) => ({
    ...state,
    schedule_list: {
      ...state.schedule_list_week,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SCHEDULE_LIST_WEEK_ERROR]: (state, action) => ({
    ...state,
    schedule_list: {
      ...state.schedule_list_week,
      error: action.payload, loading: false, hasError: true
    }
  }),
  // SLOTES LIST
  [ActionTypes.GET_SLOTES_LIST]: (state) => ({
    ...state, slotes_list: {
      ...state.slotes_list,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SLOTES_LIST_SUCCESS]: (state, action) => ({
    ...state,
    slotes_list: {
      ...state.slotes_list,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SLOTES_LIST_ERROR]: (state, action) => ({
    ...state,
    slotes_list: {
      ...state.slotes_list,
      error: action.payload, loading: false, hasError: true
    }
  }),


  [ActionTypes.GET_SLOTES_LIST_WEEK]: (state) => ({
    ...state, slotes_list_week: {
      ...state.slotes_list_week,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SLOTES_LIST_WEEK_SUCCESS]: (state, action) => ({
    ...state,
    slotes_list_week: {
      ...state.slotes_list_week,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SLOTES_LIST_WEEK_ERROR]: (state, action) => ({
    ...state,
    slotes_list_week: {
      ...state.slotes_list_week,
      error: action.payload, loading: false, hasError: true
    }
  }),


  //SCHEDULES_ON_DATE_LIST
  [ActionTypes.GET_SCHEDULES_ON_DATE_LIST]: (state) => ({
    ...state, schedules_on_date: {
      ...state.schedules_on_date,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SCHEDULES_ON_DATE_LIST_SUCCESS]: (state, action) => ({
    ...state,
    schedules_on_date: {
      ...state.schedules_on_date,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SCHEDULES_ON_DATE_LIST_ERROR]: (state, action) => ({
    ...state,
    schedules_on_date: {
      ...state.schedules_on_date,
      error: action.payload, loading: false, hasError: true
    }
  }),

  // BKI-1232:GETSLOTESONDATE 
  [ActionTypes.GET_SLOTES_ON_DATE_LIST]: (state) => ({
    ...state, slotes_on_date: {
      ...state.slotes_on_date,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SLOTES_ON_DATE_LIST_SUCCESS]: (state, action) => ({
    ...state,
    slotes_on_date: {
      ...state.slotes_on_date,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SLOTES_ON_DATE_LIST_ERROR]: (state, action) => ({
    ...state,
    slotes_on_date: {
      ...state.slotes_on_date,
      error: action.payload, loading: false, hasError: true
    }
  }),
//SEND EMAIL

[ActionTypes.SEND_EMAIL]: (state) => ({
  ...state, send_email: {
    ...state.send_email,
    loading: true, hasError: false, error: {}
  }
}),
[ActionTypes.SEND_EMAIL_SUCCESS]: (state, action) => ({
  ...state,
  send_email: {
    ...state.send_email,
    response: action.payload, loading: false, hasError: false, error: {}
  }
}),
[ActionTypes.SEND_EMAIL_ERROR]: (state, action) => ({
  ...state,
  send_email: {
    ...state.start_service,
    error: action.payload, loading: false, hasError: true, response: {}
  }
}),

  //START_SERVICE
  [ActionTypes.START_SERVICE]: (state) => ({
    ...state, start_service: {
      ...state.start_service,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.START_SERVICE_SUCCESS]: (state, action) => ({
    ...state,
    start_service: {
      ...state.start_service,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.START_SERVICE_ERROR]: (state, action) => ({
    ...state,
    start_service: {
      ...state.start_service,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //STOP_SERVICE
  [ActionTypes.STOP_SERVICE]: (state) => ({
    ...state, stop_service: {
      ...state.stop_service,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.STOP_SERVICE_SUCCESS]: (state, action) => ({
    ...state,
    stop_service: {
      ...state.stop_service,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.STOP_SERVICE_ERROR]: (state, action) => ({
    ...state,
    stop_service: {
      ...state.stop_service,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),

  //CREATESLOT

  [ActionTypes.CREATE_SLOT]: (state) => ({
    ...state, create_slot: {
      ...state.create_slot,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.CREATE_SLOT_SUCCESS]: (state, action) => ({
    ...state,
    create_slot: {
      ...state.create_slot,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.CREATE_SLOT_ERROR]: (state, action) => ({
    ...state,
    create_slot: {
      ...state.create_slot,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),


  //GET_APPOINTMENT_DETAILS_BY_ID
  [ActionTypes.GET_APPOINTMENT_DETAILS_BY_ID]: (state) => ({
    ...state, details_by_id: {
      ...state.details_by_id,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_APPOINTMENT_DETAILS_BY_ID_SUCCESS]: (state, action) => ({
    ...state,
    details_by_id: {
      ...state.details_by_id,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_APPOINTMENT_DETAILS_BY_ID_ERROR]: (state, action) => ({
    ...state,
    details_by_id: {
      ...state.details_by_id,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),

  //GET_SLOTES_DETAILS_BY_ID
  [ActionTypes.GET_SLOT_DETAILS_BY_ID]: (state) => ({
    ...state, slots_details_by_id: {
      ...state.slots_details_by_id,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SLOT_DETAILS_BY_ID_SUCCESS]: (state, action) => ({
    ...state,
    slotes_details_by_id: {
      ...state.slots_details_by_id,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SLOT_DETAILS_BY_IDERROR]: (state, action) => ({
    ...state,
    slotes_details_by_id: {
      ...state.slots_details_by_id,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),


  //GET_SCHEDULES_ON_DATE_BY_PAGINATION_LIST
  [ActionTypes.GET_SCHEDULES_ON_DATE_BY_PAGINATION_LIST]: (state) => ({
    ...state, schedules_by_pagination: {
      ...state.schedules_by_pagination,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SCHEDULES_ON_DATE_BY_PAGINATION_LIST_SUCCESS]: (state, action) => ({
    ...state,
    schedules_by_pagination: {
      ...state.schedules_by_pagination,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SCHEDULES_ON_DATE_BY_PAGINATION_LIST_ERROR]: (state, action) => ({
    ...state,
    schedules_by_pagination: {
      ...state.schedules_by_pagination,
      error: action.payload, loading: false, hasError: true
    }
  }),

  //EDIT_APPOINTMENT_DETAILS
  [ActionTypes.EDIT_APPOINTMENT_DETAILS]: (state) => ({
    ...state, edit_appointment: {
      ...state.edit_appointment,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.EDIT_APPOINTMENT_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    edit_appointment: {
      ...state.edit_appointment,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.EDIT_APPOINTMENT_DETAILS_ERROR]: (state, action) => ({
    ...state,
    edit_appointment: {
      ...state.edit_appointment,
      error: action.payload, loading: false, hasError: true
    }
  }),

  // EDIT SLOT DETAILS

  [ActionTypes.EDIT_SLOT_DETAILS]: (state) => ({
    ...state, edit_slot: {
      ...state.edit_slot,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.EDIT_SLOT_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    edit_slot: {
      ...state.edit_slot,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.EDIT_SLOT_DETAILS_ERROR]: (state, action) => ({
    ...state,
    edit_slot: {
      ...state.edit_slot,
      error: action.payload, loading: false, hasError: true
    }
  }),
  //CANCEL_APPOINTMENT
  [ActionTypes.CANCEL_APPOINTMENT]: (state) => ({
    ...state, cancel_appointment: {
      ...state.cancel_appointment,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.CANCEL_APPOINTMENT_SUCCESS]: (state, action) => ({
    ...state,
    cancel_appointment: {
      ...state.cancel_appointment,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.CANCEL_APPOINTMENT_ERROR]: (state, action) => ({
    ...state,
    cancel_appointment: {
      ...state.cancel_appointment,
      error: action.payload, loading: false, hasError: true
    }
  }),


  [ActionTypes.APPROVE_APPOINTMENT]: (state) => ({
    ...state, approve_service: {
      ...state.approve_service,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.APPROVE_APPOINTMENT_SUCCESS]: (state, action) => ({
    ...state,
    approve_servicement: {
      ...state.approve_service,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.APPROVE_APPOINTMENT_ERROR]: (state, action) => ({
    ...state,
    approve_service: {
      ...state.approve_service,
      error: action.payload, loading: false, hasError: true
    }
  }),

  //CANCEL SLOT
  [ActionTypes.CANCEL_SLOT]: (state) => ({
    ...state, cancel_slot: {
      ...state.cancel_slot,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.CANCEL_APPOINTMENT_SUCCESS]: (state, action) => ({
    ...state,
    cancel_slot: {
      ...state.cancel_slot,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.CANCEL_SLOT_ERROR]: (state, action) => ({
    ...state,
    cancel_slot: {
      ...state.cancel_slot,
      error: action.payload, loading: false, hasError: true
    }
  }),


}, initialState);

export default reducer;